export function trimUnicodeString(input: string, maxLength: number): string {
  return Array.from(input).slice(0, maxLength).join("");
}
